import { Linkedin, Twitter } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export interface TeamMember {
  name: string;
  initials: string;
  role: string;
  bio: string;
  photo?: string;
  linkedin?: string;
  twitter?: string;
}

interface TeamSectionProps {
  members: TeamMember[];
}

export function TeamSection({ members }: TeamSectionProps) {
  return (
    <section className="mb-16">
      <h2 className="text-2xl font-semibold mb-6">
        {members.length === 1 ? "Meet the Founder" : "Meet the Team"}
      </h2>
      <div className="grid gap-4 md:grid-cols-2">
        {members.map((member) => (
          <div
            key={member.name}
            className="p-6 rounded-xl border border-border bg-card flex flex-col sm:flex-row items-start gap-5"
          >
            <Avatar className="h-16 w-16 shrink-0">
              {member.photo && (
                <AvatarImage src={member.photo} alt={member.name} />
              )}
              <AvatarFallback className="text-xl font-bold bg-primary/10 text-primary">
                {member.initials}
              </AvatarFallback>
            </Avatar>
            <div>
              <h3 className="font-semibold text-lg">{member.name}</h3>
              <p className="text-sm text-primary mb-2">{member.role}</p>
              <p className="text-sm text-muted-foreground mb-3">{member.bio}</p>
              <div className="flex items-center gap-3">
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    <Linkedin className="h-4 w-4" />
                    LinkedIn
                  </a>
                )}
                {member.twitter && (
                  <a
                    href={member.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    <Twitter className="h-4 w-4" />
                    Twitter
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
